import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const LeadSearchRecord = Record({
  canUseInstantOffer: true,
  canUseInstantApplication: true,
  createdAt: new Date(0),
  id: 0,
  lastChangeAt: new Date(0),
  name: '',
  productType: 0,
  status: 0,
});

export default class LeadSearch extends LeadSearchRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const mapProperties = {
      createdAt: Hydrator.timestamp2Date,
      lastChangeAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new LeadSearch(hydrated);
  }
}
